<template>
  <div id="app">
    <img src="./assets/logo.png" width="50" height="50"/>
    <h3>{{ value }} 蓝云天(R) NewCloud 软件评测网站</h3>
    <div>
      <router-link to="/downnss">下载 NSS </router-link>&nbsp;&nbsp;&nbsp;&nbsp;|
      <router-link to="/down">下载 Speach AI </router-link>&nbsp;&nbsp;&nbsp;&nbsp;|
      <router-link to="/about">关于</router-link>
    </div>
    <!-- <div>
      <router-link to="/user/xianyu">动态路由咸鱼</router-link> | 
      <router-link to="/user/mengxiang">动态路由梦想</router-link>
    </div> -->
    <hr />
    <router-view></router-view> <br />
    <footer style="text-align: center">
      <hr />
      <div style="font-size: 12px">
        Version 1.09 2023.11.06 更新 Powered by
        <a href="http://www.newcloud.cn" target="_blank">NewCloud</a>
        <div>{{ message }}</div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  created() {
    document.title = "NewCloud";
  },
  name: "App",
  data() {
    return {
      value: "欢迎!",
      message: "",
    };
  },
  async mounted() {
    const { text } = await (await fetch("/api/message")).json();
    this.message = text;
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 0px;
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: #c4ddf1 !important;
}
texts {
  margin-top: 300px;
  margin-left: 30px;
  font-size: 16px;
}
</style>
